import React, { Component } from 'react';
import { connect } from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import authAction from '../../redux/auth/actions';
import TopbarDropdownWrapper from './topbarDropdown.style';
import Gravatar from "../../customApp/components/Gravatar";
import { clearToken } from '../../helpers/utility';

const { logout } = authAction;

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
    };
  }
  hide () {
    this.setState({ visible: false });
  }
  handleVisibleChange () {
    this.setState({ visible: !this.state.visible });
  }

  render () {
    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        <a className="isoDropdownLink" href="/private/account">
          <IntlMessages id="themeSwitcher.settings" />
        </a>
        {/* <a className="isoDropdownLink" href="# ">
          <IntlMessages id="sidebar.feedback" />
        </a>
        <a className="isoDropdownLink" href="# ">
          <IntlMessages id="topbar.help" />
        </a> */}
        <a className="isoDropdownLink" onClick={this.props.logout} href="# ">
          <IntlMessages id="topbar.logout" />
        </a>
      </TopbarDropdownWrapper>
    );

    return (
      <Popover
        content={content}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        arrowPointAtCenter={true}
        placement="bottomLeft"
      >
        <div className="isoImgWrapper">
          <Gravatar
            email="renaud.mioque@gmail.com"
            rating="g"
            size={"300"}
            displaySize={32}
            defaultImage="retro"
            alt={'Gravatar of '}
          />
          <span className="userActivity online" />
        </div>
      </Popover>
    );
  }
  logout = () => {
    clearToken();
    this.props.history.push("/")
  }
}
export default connect(
  null,
  { logout }
)(TopbarUser);
